module.exports = __webpack_public_path__ + "img/star-logo.37be4022.png";